import { FC, useState, useEffect } from "react"
import { AttachmentModel } from "./components/AttachmentModel"
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material"
import { AttachmentList } from "./AttachmentList"
import { Attachment3D } from "./components/Attachment3D"
import { TopPanel } from "./components/TopPanel"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { attachmentModule, wasmModule } from "@/gluelayer"
import { ULoading } from "@/ui-component"
import React from "react"
import {
  updateClinicalSettings,
  fetchClinicalSettings,
} from "@/core/app/slices/user/userApis"

interface SingleAttachmentProps {
  open: boolean
  onClose: () => void
}

export const SingleAttachment: FC<SingleAttachmentProps> = ({
  open,
  onClose,
}) => {
  const dispatch = useAppDispatch()
  const DefineAttachment = useAppSelector(
    (state: RootState) => state.userService.clinicalSettings.DefineAttachment,
  )

  const [wasmReady, setWasmReady] = React.useState(false)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)
  const [hasChanged, setHasChanged] = useState<boolean>(false)

  useEffect(() => {
    if (!open) {
      setWasmReady(false)
      setHasChanged(false)
    }
  }, [open])

  const passDatatoWasm = () => {
    try {
      attachmentModule.setAttachmentSelectAbleType("NormalAttachment")

      attachmentModule.SetSingleAttachmentSettingJson(
        JSON.stringify(DefineAttachment),
      )
      attachmentModule.SetOnSingleAttachmentChangedCB((_num: number) => {
        setHasChanged(true)
      })
      wasmModule.ulabwinIns.ShowSingleAttachmentSetting(0)
      console.log("DefineAttachment:", DefineAttachment)
    } catch (err) {
      console.error("Pass data to wasm failed:", err)
      setWasmReady(true)
    }

    setWasmReady(true)
  }

  const saveToService = (callback?: () => void) => {
    try {
      const json = JSON.parse(attachmentModule.GetSingleAttachmentSettingJson())
      dispatch(
        updateClinicalSettings({
          DefineAttachment: json,
        }),
      ).then((res) => {
        if (res && res.payload && res.payload.response_code === 200) {
          dispatch(fetchClinicalSettings())
          setHasChanged(false)
          callback?.()
        } else {
          console.error("Save failed")
        }
      })
    } catch (err) {
      console.error("Save to service failed:", err)
    }
  }

  // Handle close with change detection
  const handleModelClose = () => {
    if (hasChanged) {
      setConfirmDialogOpen(true)
    } else {
      onClose()
    }
  }

  // Confirm dialog - Cancel (don't save)
  const handleConfirmCancel = () => {
    setConfirmDialogOpen(false)
    onClose()
  }

  // Confirm dialog - OK (save)
  const handleConfirmOk = () => {
    setConfirmDialogOpen(false)
    saveToService(() => {
      onClose()
    })
  }

  return (
    <AttachmentModel
      title="Single Attachment"
      open={open}
      onClose={handleModelClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: 70,
          left: 18,
          width: "320px",
          height: "auto",
          zIndex: 1,
        }}
      >
        <AttachmentList
          showSave={true}
          onSaveSuccess={() => setHasChanged(false)}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: 68,
          right: 18,
          left: 340,
          height: "auto",
          zIndex: 1,
        }}
      >
        <TopPanel />
      </Box>
      <Attachment3D initCallBack={passDatatoWasm} />

      <Dialog
        open={confirmDialogOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleConfirmCancel()
          }
        }}
        maxWidth="xs"
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            pb: 1,
          }}
        >
          Confirm
        </DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 3 }}>
          Do you want to save these changes?
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleConfirmCancel}
            variant="outlined"
            sx={{ mr: 1 }}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirmOk} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <ULoading isLoading={!wasmReady} />
    </AttachmentModel>
  )
}
